module.exports = __webpack_public_path__ + "static/media/Korg-N1R-Open-Surdo.afc103f4.wav";